/**
 * @flow
 * @relayHash 42b9186852f07af25704445a18ff9bd7
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ExchangeLoaderFragment_viewer$ref = any;
export type ExchangeLoaderQueryVariables = {|
  first?: ?number,
  offset?: ?number,
  search?: ?string,
|};
export type ExchangeLoaderQueryResponse = {|
  +viewer: ?{|
    +$fragmentRefs: ExchangeLoaderFragment_viewer$ref
  |}
|};
export type ExchangeLoaderQuery = {|
  variables: ExchangeLoaderQueryVariables,
  response: ExchangeLoaderQueryResponse,
|};
*/


/*
query ExchangeLoaderQuery(
  $first: Int
  $offset: Int
  $search: String
) {
  viewer {
    ...ExchangeLoaderFragment_viewer_2pFftX
    id
  }
}

fragment ExchangeLoaderFragment_viewer_2pFftX on Query {
  exchanges(first: $first, offset: $offset, search: $search) {
    edges {
      node {
        id
        name
        symbol
      }
    }
    count
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "search",
    "variableName": "search"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ExchangeLoaderQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ExchangeLoaderFragment_viewer",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ExchangeLoaderQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Query",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "exchanges",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "ExchangeNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ExchangeNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ExchangeNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "name",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "symbol",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "count",
                "args": null,
                "storageKey": null
              }
            ]
          },
          (v2/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ExchangeLoaderQuery",
    "id": null,
    "text": "query ExchangeLoaderQuery(\n  $first: Int\n  $offset: Int\n  $search: String\n) {\n  viewer {\n    ...ExchangeLoaderFragment_viewer_2pFftX\n    id\n  }\n}\n\nfragment ExchangeLoaderFragment_viewer_2pFftX on Query {\n  exchanges(first: $first, offset: $offset, search: $search) {\n    edges {\n      node {\n        id\n        name\n        symbol\n      }\n    }\n    count\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2c965ed541f2eceb95168e9477b61b16';
module.exports = node;
